import { __awaiter } from "tslib";
import { registerWebPlugin, WebPlugin } from "@capacitor/core";
export class InsetsWeb extends WebPlugin {
    constructor() {
        super({
            name: 'Insets',
            platforms: ['web'],
        });
    }
    getInsets() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            };
        });
    }
    ;
}
const Insets = new InsetsWeb();
export { Insets };
registerWebPlugin(Insets);
//# sourceMappingURL=web.js.map